import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { queries as happeningNowQueries } from "domains/home/containers/HappeningNow/queries";
import { queries as homeDataQueries } from "domains/home/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: ForManagerLocationDetail; now: Date };

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  ...homeDataQueries(input),
  ...happeningNowQueries(input),
];
